<div *ngIf="!loading"
	 class="fb-filter-control flex flex-col justify-start items-stretch my-1">
	<div *ngIf="control.key.type !== 'toggle' && control.key.key !== 'category'"
		 class="flex flex-row justify-between items-stretch">

		<h3 class="capitalize text-lg font-semibold mb-3">{{ control.title }}</h3>
		<div (click)="toggleCollapse()">
			<span *ngIf="!collapse" class="f-fc-pointer">
				<span class="material-symbols-outlined">remove</span>
			</span>
			<span *ngIf="collapse" class="f-fc-pointer">
				<span class="material-symbols-outlined">add</span>
			</span>
		</div>
	</div>
	<ng-container >
		<ng-container *ngIf="control.cohort">
			<ng-container *ngFor="let option of control.cohort.options; let i = index;">
					<mat-checkbox *ngIf="control.key.type === 'default' && control.key.key !== 'category'"
								  color="primary"
								  (change)="onChange()"
								  [(ngModel)]="option.active"
								  [ngClass]="collapse ? 'f-fc-filter-checkbox-hide' : 'f-fc-filter-checkbox'"
								  class="f-fc-filter-checkbox capitalize rl-font-ft text-base">
						<span class="f-fc-filter-checkbox-text">{{ option.value }}</span>
					</mat-checkbox>

				<ng-container *ngIf="control.key.type === 'sub'">
					<ng-container *bmxShow="fullView? true : (i <= 1)">
						<mat-checkbox
							color="primary"
							(change)="onMainChange(option)"
							[(ngModel)]="option.active"
							[ngClass]="collapse ? 'f-fc-filter-checkbox-hide' : 'f-fc-filter-checkbox'"
							class="f-fc-filter-checkbox rl-font-ft text-base font-medium text-[#9c8a6c]">
							<span class="f-fc-filter-checkbox-text">{{ option.value }}</span>
						</mat-checkbox>
						<mat-checkbox *ngFor="let subOption of option.subOptions; let i = index;"
									  color="primary"
									  (change)="onSubChange(option)"
									  [(ngModel)]="subOption.active"
									  [ngClass]="collapse ? 'f-fc-filter-checkbox-hide' : 'f-fc-filter-checkbox'"
									  class="ml-5 f-fc-filter-checkbox capitalize rl-font-ft text-sm">
							<span class="f-fc-filter-checkbox-text">{{ subOption.value }}</span>
						</mat-checkbox>
					</ng-container>

				</ng-container>

				<ng-container *ngIf="control.key.type === 'csv'">
					<ng-container *bmxShow="fullView? true : (i <=4)">
						<mat-checkbox *ngIf="control.key.key === 'color'"
									  color="primary"
									  (change)="onChange()"
									  [(ngModel)]="option.active"
									  [ngClass]="collapse ? 'f-fc-filter-checkbox-hide' : 'f-fc-filter-checkbox'"
									  class="f-fc-filter-checkbox capitalize rl-font-ft text-base">
							<div class="f-fc-filter-checkbox-text flex flex-row items-center gap-2">
								<div class="w-7 h-7 rounded-full mr-1 border border-black"
									 [ngStyle]="{'background-color': getColorHex(option)}"></div>
								{{ getMetadataValue(option)? getMetadataValue(option) : "" }}
							</div>
						</mat-checkbox>
						<mat-checkbox *ngIf="control.key.key !== 'color'"
									  color="primary"
									  (change)="onChange()"
									  [(ngModel)]="option.active"
									  [ngClass]="collapse ? 'f-fc-filter-checkbox-hide' : 'f-fc-filter-checkbox'"
									  class="f-fc-filter-checkbox capitalize rl-font-ft text-base">
					<span class="f-fc-filter-checkbox-text">
						{{ getMetadataValue(option)? getMetadataValue(option) : "" }}
					</span>
						</mat-checkbox>
					</ng-container>

				</ng-container>
			</ng-container>
			<button *ngIf="!collapse && (control.key.type === 'sub') && control.cohort.options.length > 1"
					(click)="fullView = !fullView"
					class="w-full rounded border-2 border-[#8E7862]/60 text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm mb-4">
				{{ fullView? 'Show Less' : 'Show More' }}
				<span class="material-symbols-outlined">
					{{ fullView? 'expand_less' : 'expand_more' }}
				</span>
			</button>
			<button *ngIf="!collapse && !(control.key.type === 'sub') && control.cohort.options.length > 4"
					(click)="fullView = !fullView"
					class="w-full rounded border-2 border-[#8E7862]/60 text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm mb-4">
				{{ fullView? 'Show Less' : 'Show More' }}
				<span class="material-symbols-outlined">
					{{ fullView? 'expand_less' : 'expand_more' }}
				</span>
			</button>
		</ng-container>

		<ng-container *ngIf="!collapse && control.rangeCohort">
			<fb-filter-range-control [control]="control.rangeCohort"
									 (onControlChange)="onChange()"></fb-filter-range-control>
		</ng-container>
	</ng-container>
</div>
